<script lang="ts">
import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

export default {
    name: 'BaseEntityPanel',
    props: {
        data: { type: Object, required: true },
        entity: { type: BaseModel, required: false, default: {} },
    },
    computed: {
        translationName(): string {
            return this.entity?.translationKey ?? ''
        },
        validationRules() {
            if (this.$parent?.i3pService?.editMode) // TO DO : Importer le service ici ?
                return this.entity?.getRules()

            return null
        },
        validation(): any {
            if (this.$parent?.i3pService?.editMode) // TO DO : Importer le service ici ?
                return this.$parent?.v$?.entity.data

            return null
        },
    },

}
</script>
